import type { WatchProgress } from './types';

const RESUME_AFTER_SECONDS = 15;
const MIN_REMAINING_SECONDS = 60;

export function resumablePosition(
  progress: WatchProgress | undefined,
  mediaDuration = 0,
): number | null {
  if (!progress || !Number.isFinite(progress.currentTime)) return null;
  const duration = mediaDuration > 0 ? mediaDuration : progress.duration;
  if (progress.currentTime < RESUME_AFTER_SECONDS) return null;
  if (duration > 0 && duration - progress.currentTime < MIN_REMAINING_SECONDS) return null;
  return progress.currentTime;
}
